import React from "react";
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";

import { useAll as useSpheres } from "modules/sphere/hooks";
import { useAll as useOrganizations } from "modules/organization/hooks";

import * as Grid from "components/Grid";

import Input from "components/Input";
import Select from "components/Select";
import Button from "components/Button";

const FilterList = ({ params, setParams, setSearch }) => {
  const { t, i18n } = useTranslation();

  const sphere = useSpheres();
  const organization = useOrganizations();

  return (
    <Grid.Row gutter={20}>
      <Grid.Col xs={5}>
        <Select
          onChange={v => setParams({ organization_id: v })}
          showSearch
          options={[
            { label: t("all_organization"), value: "" },
            ...organization.items.map(item => ({
              label: item.name[i18n.language],
              value: item.id,
            })),
          ]}
          value={Number(params.organization_id) || ""}
          placeholder={t("column_organization")}
          disabled={!organization.isFetched}
        />
      </Grid.Col>

      <Grid.Col xs={4}>
        <Select
          onChange={v => setParams({ sphere_id: v })}
          showSearch
          options={[
            { label: t("all_sphere"), value: "" },
            ...sphere.items.map(item => ({ label: item.name, value: item.id })),
          ]}
          value={Number(params.sphere_id) || ""}
          placeholder={t("column_sphere")}
          disabled={!sphere.isFetched}
        />
      </Grid.Col>

      <Grid.Col xs={4}>
        <Input
          onChange={e => setParams({ function_name: e })}
          placeholder={t("column_service_name")}
          value={params.function_name}
        />
      </Grid.Col>

      <Grid.Col xs={4}>
        <Select
          onChange={e => setParams({ personal: e })}
          options={[
            {
              label: t("service_type_all"),
              value: "",
            },
            {
              label: t("service_online"),
              value: "online",
            },
            {
              label: t("service_onsite"),
              value: "onsite",
            },
          ]}
          placeholder={t("column_service_form")}
          value={""}
        />
      </Grid.Col>
      <Grid.Col xs={2}>
        <Select
          onChange={e => setParams({ users: e })}
          options={[
            {
              label: t("users_all"),
              value: "",
            },
          ]}
          placeholder={t("column_users")}
          value={params.users || ""}
        />
      </Grid.Col>

      <Grid.Col xs={2}>
        <Select
          onChange={e => setParams({ payment: e })}
          options={[
            {
              label: t("payment_type"),
              value: "",
            },
          ]}
          placeholder={t("column_payment_type")}
          value={""}
        />
      </Grid.Col>
      <Grid.Col xs={2}>
        <Button
          background="blue"
          color="white"
          border="blue"
          radius="sm"
          onClick={() => setSearch(prev => prev + 1)}>
          <Icons.Search /> {t("find")}
        </Button>
      </Grid.Col>
    </Grid.Row>
  );
};

export default FilterList;
